import request from '@/utils/request'
import requestAuth from '@/utils/requestAuth'

// 地址栏获取token
export function PostTokenAuto(data) {
  return request({
    url: `telecom/getToken`,
    method: 'post',
    data
  })
}

/** 获取token */
export function PostToken(data) {
  const dataTemp = `username=${data.userName}&password=${data.passWord}&grant_type=password&scope=all&client_id=client&client_secret=secret`
  return requestAuth({
    url: '/oauth/token',
    method: 'post',
    data: dataTemp
  })
}

/** 拉取取权限 */
export function login(data) {
  return request({
    url: 'loginByMobile',
    method: 'post',
    data
  })
}


/** 拉取取权限 */
export function thirdLogin(data) {
  return request({
    url: `/user/getToken`,
    method: 'post',
    params:data
  })
}


/** 拉取取权限 */
export function getVersion(data) {
  return request({
    url: `/select/getTagInfo`,
     method: 'get',
  })
}

